import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { toCurrency } from 'utilities/currency';

const ReceiptItem = ({
  label,
  cost,
  currency,
  override = null, // used instead of cost if present
  emphasize = false, // used to make bold
  isTax = false,
  isShipping = false,
  negativeZero = false,
  topOffset = 1,
  bottomOffset = 0,
  leftOffset = 0,
  rightOffset = 0,
}) => {
  const { t, i18n } = useTranslation();

  const key = i18n.exists(label) ? t(label) : label;

  let value;
  if (override) {
    value = i18n.exists(override) ? t(override) : override;
  } else {
    value =
      cost === ('0.0' || 0) && !isTax && !negativeZero && isShipping // zero tax should not display 'free'
        ? t('checkout.label.free')
        : cost === ('0.0' || 0) && negativeZero
          ? toCurrency('-0.0', currency)
          : toCurrency(cost, currency);
  }

  return (
    <Grid
      container
      justifyContent="space-between"
      sx={{
        pt: topOffset,
        pb: bottomOffset,
        pl: leftOffset,
        pr: rightOffset,
      }}
    >
      <Grid item>
        <p className={emphasize ? 'semibold-30' : 'paragraph-20'}>{key}</p>
      </Grid>
      <Grid item>
        <p className={emphasize ? 'semibold-30' : 'paragraph-20'}>{value}</p>
      </Grid>
    </Grid>
  );
};

export default ReceiptItem;
